import React from 'react';
import { BrowserRouter as Router, Redirect } from 'react-router-dom';
import firebase from 'firebase';
import Generate from './helpers/generate';
import Notifications, {notify} from 'react-notify-toast';
import GoogleAnalytics from 'react-ga';

class JoinGame extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			complete: false,
			profile: null
		};

		// console.log('JoinGame this.props',this.props)

	}

	componentDidMount() {
		// Check if a profile already exists
		firebase.database().ref(`profiles/${this.props.gameId}/${this.props.user.uid}`).on('value', (result) => {
			if(result.val()) {
				// console.log('profile found',result.val());
				this.setState({profile: result.val()});
				this.setState({complete: true});
			}
			else {
				// console.log('no profile found, creating one');
				Generate.profile(this.props.gameId, this.props.user)
				.then(response => {

					GoogleAnalytics.event({
						category: 'Interaction',
						action: 'JoinGame',
						label: this.props.gameId,
						nonInteraction: false
					});
					this.setState({profile: response});
					this.setState({ complete: true });

				})
				.catch(error => {
					console.warn('profile creation error', error)
					notify.show("Error Joining Game", "error")
				})
			}
		});

		// Create Profile

	}

	render() {

		if (this.state.complete && this.state.profile) {
			return <Redirect to={`/game/${this.props.gameId}/profile/${this.state.profile.id}`}/>;
		}

		return <section className="join">
		<header>
		<h1>Creating your Profile</h1>
		<h6>{this.props.gameId}</h6>
		</header>

		<main>
		<div>
		</div>
		</main>

		</section>;
	}
}

export default JoinGame



// WEBPACK FOOTER //
// ./src/components/join.js